module.exports = __webpack_public_path__ + "static/media/5.d9521703.png";